import React, {useRef, useEffect, useCallback} from 'react';
import {map} from 'lodash';

import colors from 'shared/aptitude/colors';

const colorMap = {
  blue: colors.b500,
  red: colors.r500,
};

interface Props {
  gaugeInfo: {
    onTrackPercentage: number;
    text: string[];
  };
  color?: 'blue' | 'red';
}

const InProgressGauge = ({gaugeInfo, color = 'blue'}: Props) => {
  const canvas = useRef<HTMLCanvasElement>(null);

  const renderGauge = useCallback(
    (percentage: number) => {
      const gaugeStyle = {
        percent: 0,
        size: 60,
        lineWidth: 8,
        rotate: 0,
      };

      const canvasElement = canvas.current;
      if (!canvasElement) return;

      const radius = (gaugeStyle.size - gaugeStyle.lineWidth) / 2;
      const pixelRatio = window.devicePixelRatio || 1;

      canvasElement.style.width = gaugeStyle.size + 'px';
      canvasElement.style.height = gaugeStyle.size + 'px';
      canvasElement.width = gaugeStyle.size * pixelRatio;
      canvasElement.height = gaugeStyle.size * pixelRatio;

      const ctx = canvasElement.getContext('2d');

      if (!ctx) {
        return null;
      }

      ctx.scale(pixelRatio, pixelRatio);
      ctx.clearRect(0, 0, canvasElement.width, canvasElement.height);
      ctx.translate(gaugeStyle.size / 2, gaugeStyle.size / 2);
      ctx.rotate((-1 / 2 + gaugeStyle.rotate / 180) * Math.PI);

      const drawGauge = (strokeColor: string, lineWidth: number, percent: number) => {
        percent = Math.min(Math.max(0, percent || 1), 1);
        ctx.beginPath();
        ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false);
        ctx.strokeStyle = strokeColor;
        ctx.lineCap = 'round';
        ctx.lineWidth = lineWidth;
        ctx.stroke();
      };

      drawGauge(colors.n300, gaugeStyle.lineWidth, 1);
      if (percentage) {
        drawGauge(colorMap[color], gaugeStyle.lineWidth, percentage);
      }
    },
    [color]
  );

  useEffect(() => {
    renderGauge(gaugeInfo.onTrackPercentage);
  }, [gaugeInfo.onTrackPercentage, renderGauge]);

  return (
    <div className="on-track-in-progress-gauge" data-testid="on-track-in-progress-gauge">
      <div className="on-track-in-progress-gauge-canvas-container">
        <canvas ref={canvas} />
      </div>
      <div className="on-track-in-progress-gauge-text-container">
        <h1 className="on-track-in-progress-gauge-header">Add Courses</h1>
        {map(gaugeInfo.text, (text, i) => (
          <p key={i} className="on-track-in-progress-gauge-text">
            {text}
          </p>
        ))}
      </div>
    </div>
  );
};

export default InProgressGauge;
